
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.614 1.5H1.769A.769.769 0 001 2.27v18.455c0 .424.344.769.769.769h3.845a.769.769 0 00.769-.77V2.27a.769.769 0 00-.77-.769z","stroke":"#339299","stroke-width":"1.538","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.997 4.577H7.152a.769.769 0 00-.77.769v15.379c0 .425.345.769.77.769h3.845a.769.769 0 00.769-.769V5.345a.769.769 0 00-.77-.768zM16.143 4.155l-2.984.747a.769.769 0 00-.559.932l3.734 14.92c.103.412.52.662.933.559l2.983-.747a.769.769 0 00.56-.932l-3.734-14.92a.769.769 0 00-.933-.56zM1 16.11h5.383M6.383 14.573h5.383M15.61 17.649l4.43-1.108","stroke":"#339299","stroke-width":"1.538","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    